import { Navigate, useLocation } from "react-router-dom";
import { z } from "zod";

import { LaunchFailureSchema } from "../../../hooks/useOptroLaunchResolve";
import { LAUNCH_FAILURE_COPY } from "./launchFailureCopy";

// Route state is untrusted (history entries survive deploys); the shared zod
// enum is the source of truth for failure kinds, and the copy map's
// Record<LaunchFailure, string> type keeps it exhaustive against the enum —
// no key re-derivation, no cast, immune to prototype keys like "toString".
const FailureStateSchema = z.object({
  failure: LaunchFailureSchema,
});

// In-nav by design (under the /audit layout) — navigation is the only CTA.
// Direct visits without valid route state fall through to /audit.
export const OptroLaunchFailedPage = () => {
  const { state } = useLocation();
  const parsed = FailureStateSchema.safeParse(state);

  if (!parsed.success) {
    return <Navigate to="/audit" replace />;
  }
  const { failure } = parsed.data;

  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 px-6 pt-24 text-center">
      <p className="text-base font-medium text-stone-900">
        We couldn't open your test
      </p>
      <p className="max-w-md text-sm text-stone-500">
        {LAUNCH_FAILURE_COPY[failure]}
      </p>
    </div>
  );
};
